import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import taskbg from "../Pages/taskBG.png";
import "../Pages/task.css";
import { useNavigate } from "react-router-dom";

const coverContent = {
  backgroundColor: "#f3d13717",
  borderRadius: "0px",
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: "40px 20px",
};

export default function LoginPage() {
  const navigate = useNavigate();
  return (
    <Container fluid className="vh-100 d-flex p-0">
      <Row className="w-100 m-0">
        {/* Left side - Graphic or Image */}
        <Col
          md={6}
          className="d-flex align-items-center justify-content-center text-white"
          style={{
            backgroundImage: `url(${taskbg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            padding: "0px"
          }}
        >
          <div className="text-center p-4 " style={coverContent}>
            <h1 style={{fontWeight: '900', color: '#413719'}}>Welcome Back!</h1>
            <p style={{fontSize: '24px', color: '#413719',fontWeight: '500', textTransform: 'capitalize' }}>Sign in and continue your journey.</p>
          </div> 
        </Col>

        {/* Right side - Login Form */}
        <Col md={6} className="d-flex align-items-center justify-content-center bg-light p-5 py-0">
          <div style={{ maxWidth: "420px", width: "100%" }} className="log-box">
            <h2 className="mb-4 text-center fw-bold">Login</h2>
            <Form>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email" placeholder="Enter your email" />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Enter your password" />
              </Form.Group>

              <div className="d-flex justify-content-between mb-3">
                {/* <Form.Check type="checkbox" label="Remember me" /> */}
                <a href="/teams" className="text-decoration-none">Forgot password?</a>
              </div>

              <div className="d-grid gap-2">
                <Button variant="link" type="submit" className="btnLog" onClick={() => navigate('/group')}>
                  Login
                </Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
}